<template lang='pug'>
  header
    .container-content-small-header(v-if="!noHeader")
      .display-block 
        slot(name="left")
      .display-block 
        slot(name="right")
    .container-content
      slot
</template>

<script>
export default {
  props: {
    noHeader: {
      type:     Boolean,
      default:  false,
    }
  }
};
</script>


<style lang="less">
@import (reference) "../assets/general";
.container-content-small-header {
  .flex(center, space-between);
  padding-bottom:   10px;
  
  h3 {
    margin:     0;
    font-size:  @font-size-primary;
    font-weight: normal;
  }
}

.container-content {
  .max-width;
}
</style>
